@if (visible) {
  <div
    class="modal-overlay fixed inset-0 bg-gray-700 bg-opacity-50 overflow-y-auto h-full w-full z-40"
  ></div>
}

<!-- Main modal wrapper -->
<div
  [style.display]="visible ? 'flex' : 'none'"
  tabindex="-1"
  class="modal-content fixed inset-0 z-50 flex items-start justify-center overflow-y-auto p-4 md:pt-20 md:pb-10"
>
  <!-- Modal container -->
  <div class="relative w-full max-w-4xl my-auto">
    <!-- Modal content -->
    <div
      class="flex max-h-[calc(100vh-4rem)] flex-col overflow-hidden rounded-lg bg-white shadow dark:bg-gray-700 md:max-h-[calc(100vh-7rem)]"
    >
      <!-- Modal header -->
      <div
        class="sticky top-0 z-10 flex items-center justify-between border-b rounded-t bg-white p-4 dark:border-gray-600 dark:bg-gray-700 md:p-5"
      >
        <h3 class="text-xl font-medium text-gray-900 dark:text-white">
          {{ title }}
        </h3>
        <button
          type="button"
          class="text-gray-400 hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
          (click)="closeModal()"
        >
          <svg
            class="w-3 h-3"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 14 14"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
            />
          </svg>
        </button>
      </div>

      <!-- Modal body (scrollable content) -->
      <div class="modal-body flex-1 overflow-y-auto p-4 space-y-6">
        @if (videoVisible) {
          <!-- YouTube Video -->
          <div class="w-full aspect-video rounded-lg overflow-hidden shadow">
            <iframe
              class="w-full h-full"
              src="https://www.youtube-nocookie.com/embed/lzMdpI6La8Q"
              title="YouTube video player"
              allowfullscreen
            ></iframe>
          </div>
        }
        <!-- PDF -->
        @if (visible && pdfSrc) {
          <ngx-extended-pdf-viewer
            [src]="pdfSrc"
            [height]="'60vh'"
            [page]="1"
            [textLayer]="true"
            [showToolbar]="false"
          ></ngx-extended-pdf-viewer>
        }
      </div>

      <!-- Footer -->
      <div
        class="sticky bottom-0 flex justify-center border-t bg-white p-4 dark:border-gray-600 dark:bg-gray-700"
      >
        <button
          class="text-white w-1/2 bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          (click)="downloadPDF()"
        >
          DOWNLOAD
        </button>
      </div>
    </div>
  </div>
</div>
